export class DocumentFileSearch {
  page: number;
  queryString: string;
  companyId: string;
  userId: string;
  department: string;
  competence:string;
  type: string;
  typeUser?: string;
}
